import { APIService } from '@apparel/core/api';
import { PlatformService, PlatformTag } from '@apparel/core/platform';
import { Platform } from '@apparel/core/platform/Platform';
import { useContext, useMemo } from 'react';
import { PlatformContext } from './PlatformContext';

export function usePlatform(defaultPlatform?: PlatformTag): Platform {
    const docPlatform = useMemo(() => PlatformService.instance.getDocumentPlatform(), []);

    const ctx = useContext(PlatformContext) || defaultPlatform || docPlatform || APIService.getPlatform();
    return useMemo(() => Platform.from(ctx), [ctx]);
}
